(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/hooks/hooks.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/hooks/hooks.js');
"use strict";


const {
  useCallback,
  useEffect,
  useState
} = React;
const {
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  START
} = svs.ticket_partner.constants.routes;
const useLocalStorage = function (key) {
  let initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let expirationTimeMS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      const itemValue = item ? JSON.parse(item) : initialValue;
      const now = new Date().getTime();
      const hasExpired = expirationTimeMS && (itemValue === null || itemValue === void 0 ? void 0 : itemValue.exp) && itemValue.exp < now;
      if (hasExpired) {
        return initialValue;
      }
      return itemValue;
    } catch (error) {
      return initialValue;
    }
  });
  const setValue = useCallback(value => {
    setStoredValue(storedValue => {
      try {
        const valueToStore = typeof value === 'function' ? value(storedValue) : value;
        if (expirationTimeMS) {
          valueToStore.exp = new Date().getTime() + expirationTimeMS;
        }
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
        return valueToStore;
      } catch (error) {
        return storedValue;
      }
    });
  }, [key, expirationTimeMS]);
  return [storedValue, setValue];
};
const useReturnUrl = function () {
  let defaultRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : START;
  const history = useHistory();
  const location = useLocation();
  const returnUrl = svs.utils.paramHandler.get({
    key: 'returnUrl'
  }).value;
  const route = Object.values(svs.ticket_partner.constants.routes).find(route => route === returnUrl);
  const redirectToStartPage = useCallback(() => {
    history.push(defaultRoute);
  }, [defaultRoute, history]);
  const redirectToReturnUrl = useCallback(() => {
    const redirectTo = route || defaultRoute;
    history.push(redirectTo);
  }, [route, defaultRoute, history]);
  const redirectToKeepReturnUrl = useCallback(to => {
    const redirectTo = to || defaultRoute;
    let search = '';
    if (route && redirectTo !== route) {
      search = "?returnUrl=".concat(route);
    }
    history.push("".concat(redirectTo).concat(search));
  }, [route, defaultRoute, history]);
  const redirectToWithBackReturnUrl = useCallback(to => {
    const redirectTo = to || defaultRoute;
    let search = '';
    if (redirectTo !== location.pathname) {
      search = "?returnUrl=".concat(location.pathname);
    }
    history.push("".concat(redirectTo).concat(search));
  }, [defaultRoute, history, location.pathname]);
  const redirectToKeepReturnUrlOrBack = useCallback(to => {
    const redirectTo = to || defaultRoute;
    if (route && redirectTo !== route) {
      redirectToKeepReturnUrl(redirectTo);
    } else {
      redirectToWithBackReturnUrl(redirectTo);
    }
  }, [defaultRoute, route, redirectToKeepReturnUrl, redirectToWithBackReturnUrl]);
  return {
    returnUrl: route,
    redirectToStartPage,
    redirectToReturnUrl,
    redirectToKeepReturnUrl,
    redirectToWithBackReturnUrl,
    redirectToKeepReturnUrlOrBack
  };
};
const useBreakpointGreaterThan = breakpoint => {
  const [greaterThan, setGreaterThan] = useState(svs.core.detect.breakpoint.greaterThan(breakpoint));
  useEffect(() => {
    const onBreakPointChange = () => {
      setGreaterThan(svs.core.detect.breakpoint.greaterThan(breakpoint));
    };
    svs.core.detect.breakpoint.on('change', onBreakPointChange);
    return () => {
      svs.core.detect.breakpoint.off('change', onBreakPointChange);
    };
  }, [breakpoint]);
  return [greaterThan];
};
const usePromiseDeferred = () => {
  const [promise] = useState(() => {
    const p = {};
    p.promise = new Promise((resolve, reject) => {
      p.resolve = resolve;
      p.reject = reject;
    });
    return p;
  });
  return promise;
};
svs.ticket_partner.sharedComponents.hooks = {
  useReturnUrl,
  useLocalStorage,
  useBreakpointGreaterThan,
  usePromiseDeferred
};

 })(window);